module.exports = __webpack_public_path__ + "img/upi_success.1829be72.jpg";